'use strict';

import InterNACHI from 'shared/InterNACHI.js';

if (__PRODUCTION__) {
	try {
		const bugsnag = require('bugsnag-js');
		window.bugsnagClient = bugsnag('4769c97d19b5b4fcf2d0f4b6acca7026');
		
		InterNACHI.session.onLoaded(() => {
			window.bugsnagClient.user = {
				id: window.logged_in_user.id,
				email: window.logged_in_user.email,
			};
		});
	} catch (e) {
		//
	}
}
